import React, { useState, useEffect } from 'react';
import Header from '../../common/Header/Header';
import Pagination from '../../dashboard/Pagination/Pagination';
import Container from '@mui/material/Container';
import filterByText from '../../../filters/filterByText';
import { useSelector } from "react-redux";
import Grid from '../../starred/Grid/Grid';
import Grid2 from '@mui/material/Unstable_Grid2';
import Search from '../../dashboard/Search/Search';
import Button from '../../common/Button/Button';
import { Link } from 'react-router-dom';
import './Starred.css';
import Footer from '../../common/Footer/Footer';
import scrollToTop from '../../../functions/scrollToTop';

const Starred = () => {
  // Redux state: List of all coins
  const coins = useSelector((state) => state.coins);

  // State to manage starred coins
  const [starredCoins, setStarredCoins] = useState([]);

  // State to manage current page for pagination
  const [currentPage, setCurrentPage] = useState(1);

  // State to manage the list of starred coins for the current page
  const [paginatedStarredCoins, setPaginatedStarredCoins] = useState([]);

  // State to manage search text
  const [searchText, setSearchText] = useState("");

  // Set the document title
  document.title = `Starred | InsightCoin`;

  // Scroll to the top of the page when the component mounts
  useEffect(() => {
    scrollToTop();
  }, []);

  // Update the list of starred coins when the Redux state changes
  useEffect(() => {
    let data = coins.filter((elem) => elem.starred === true);
    setStarredCoins(data);
  }, [coins]);

  // Update the list of starred coins for the current page
  useEffect(() => {
    updatePaginatedStarredCoins();
    setSearchText("");
  }, [currentPage, starredCoins]);

  // Update the list of starred coins when the search text changes
  useEffect(() => {
    if (searchText === "") {
      updatePaginatedStarredCoins();
    } else {
      let filteredStarredCoins = filterByText(searchText, [...starredCoins]);
      setPaginatedStarredCoins([...filteredStarredCoins].splice((1 - 1) * 10, 10));
    }
  }, [searchText, starredCoins]);

  // Function to update the list of starred coins for the current page
  const updatePaginatedStarredCoins = () => {
    let arr = [...starredCoins].splice((currentPage - 1) * 10, 10);
    setPaginatedStarredCoins(arr);
    if (arr.length === 0 && currentPage >= 2) {
      setCurrentPage(currentPage - 1);
    }
  };

  // Function to handle search bar input
  const handleSearchBar = (e) => {
    let text = e.target.value;
    setSearchText(text);
    if (text === "") {
      updatePaginatedStarredCoins();
    } else {
      let filteredStarredCoins = filterByText(text, [...starredCoins]);
      setPaginatedStarredCoins([...filteredStarredCoins].splice((1 - 1) * 10, 10));
    }
  };

  // Function to handle page change in pagination
  const handlePageChange = (event, page) => {
    scrollToTop();
    setCurrentPage(page);
  };

  // JSX structure for the Starred component
  return (
    <>
      {/* Header component */}
      <Header />
      <Container maxWidth="lg">
        {/* Grid2 container for search bar and button */}
        <Grid2 container spacing={2}>
          {/* Grid2 item for search bar */}
          <Grid2 xs={12} sm={6} key={56}>
            <Search searchText={searchText} handleSearchBar={handleSearchBar} />
          </Grid2>
          {/* Grid2 item for explore more coins button */}
          <Grid2 xs={12} sm={6} key={76}>
            <div style={{ paddingTop: "12px" }}></div>
            <Link to="/coins">
              <Button text={"Explore more coins"} onClick={() => {}} />
            </Link>
          </Grid2>
        </Grid2>
        <br />
        {/* Grid2 container for paginated starred coins */}
        <Grid2 container spacing={2}>
          {/* Map through paginated starred coins and render Grid2 items */}
          {paginatedStarredCoins.map((coin, i) => (
            <Grid2 xs={12} sm={6} md={4} lg={3} key={i}>
              <Grid coin={coin} index={i} key={i} />
            </Grid2>
          ))}
        </Grid2>
      </Container>
      {/* Container for the "No starred coins" message */}
      <Container maxWidth="lg">
        {starredCoins.length === 0 ? (
          <div className="no-starred40">
            <p>Oops, you haven't starred any coin yet.</p>
          </div>
        ) : (
          <></>
        )}
      </Container>
      <br />
      {/* Pagination component */}
      <Pagination handlePageChange={handlePageChange} page={currentPage} />
      {/* Footer component */}
      <Footer />
    </>
  );
}

export default Starred;
